var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-input',_vm._b({staticClass:"va-rich-text-input"},'va-input',_vm.$props,false),[_c('vue-editor',{attrs:{"editor-toolbar":_vm.customToolbar},on:{"change":_vm.change,"input":_vm.updateText},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }